import { render, staticRenderFns } from "./WorkDynamic.vue?vue&type=template&id=27024bcc&scoped=true&"
import script from "./WorkDynamic.vue?vue&type=script&lang=ts&"
export * from "./WorkDynamic.vue?vue&type=script&lang=ts&"
import style0 from "./WorkDynamic.vue?vue&type=style&index=0&id=27024bcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27024bcc",
  null
  
)

export default component.exports